"use strict";

/**
 * Locale mappings from https://wiki.stubcorp.com/pages/viewpage.action?pageId=44341715, arranged by
 * target locale (l10n locale). All keys and values in this object must be in BCP 47 format and must
 * be valid locales according to the ICU locales list at http://www.localeplanet.com/icu/index.html
 *
 * All locales for which we intend to localize our UI strings must appear here as values in this
 * mapping object, or the runtime selection of those localized strings may not work properly.
 *
 * Note: We do not include 'en-US' here because it's not on the mapping page. We do not localize to
 * 'en-US'. Developers edit 'en' files.
 */
var siteLocaleToL10nLocale = {
  // Ca-ES
  'ca-ES': 'ca-ES',
  // Cs-CZ
  'cs-CZ': 'cs-CZ',
  // Da-DK
  'da-DK': 'da-DK',
  // De-DE
  'de-AT': 'de-DE',
  // Mapped
  'de-CH': 'de-DE',
  // Mapped
  'de-DE': 'de-DE',
  'de-LU': 'de-DE',
  // Mapped
  // El-GR
  'el-GR': 'el-GR',
  // En-GB
  'en-AU': 'en-GB',
  // Mapped
  'en-CA': 'en-GB',
  // Mapped
  'en-GB': 'en-GB',
  'en-HK': 'en-GB',
  // Mapped
  'en-IE': 'en-GB',
  // Mapped
  'en-IN': 'en-GB',
  // Mapped
  'en-NZ': 'en-GB',
  // Mapped
  'en-PH': 'en-GB',
  // Mapped
  'en-SG': 'en-GB',
  // Mapped
  'en-ZA': 'en-GB',
  // Mapped
  'en-ZW': 'en-GB',
  // Mapped
  // Es-AR
  'es-AR': 'es-AR',
  'es-UY': 'es-AR',
  // Mapped
  // Es-CO
  'es-CO': 'es-CO',
  // Es-ES
  'es-CL': 'es-ES',
  // Mapped
  'es-EC': 'es-ES',
  // Mapped
  'es-ES': 'es-ES',
  'es-PE': 'es-ES',
  // Mapped
  'es-SV': 'es-ES',
  // Mapped
  'es-VE': 'es-ES',
  // Mapped
  // Es-MX
  'es-MX': 'es-MX',
  'es-US': 'es-US',
  // Value changed from es_MX to es-ES as part of ENI-1685
  // Fi-FI
  'fi-FI': 'fi-FI',
  // Fr-CA
  'fr-CA': 'fr-CA',
  // Fr-FR
  'fr-BE': 'fr-FR',
  // Mapped
  'fr-CH': 'fr-FR',
  // Mapped
  'fr-FR': 'fr-FR',
  'fr-LU': 'fr-FR',
  // Mapped
  // Id-ID
  'id-ID': 'id-ID',
  // It-IT
  'it-IT': 'it-IT',
  // Ja-JP
  'ja-JP': 'ja-JP',
  // Ko-KR
  'ko-KR': 'ko-KR',
  // Nb-NO
  'nb-NO': 'nb-NO',
  // Nl-NL
  'nl-BE': 'nl-NL',
  // Mapped
  'nl-NL': 'nl-NL',
  // Pl-PL
  'pl-PL': 'pl-PL',
  // Pt-BR
  'pt-BR': 'pt-BR',
  // Pt-PT
  'pt-PT': 'pt-PT',
  // Ru-RU
  'ru-RU': 'ru-RU',
  'ru-UA': 'ru-RU',
  // Mapped
  // Sv-SE
  'sv-SE': 'sv-SE',
  // Tr-TR
  'tr-TR': 'tr-TR',
  // Zh-CN
  'zh-CN': 'zh-CN',
  // Zh-HK
  'zh-HK': 'zh-HK',
  'zh-TW': 'zh-TW'
};
module.exports = {
  siteLocaleToL10nLocale: siteLocaleToL10nLocale
};